export default __webpack_public_path__ + "static/media/iconbutton-multiplewindows-light-sidebar-disabled.68906522.svg";